import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Menu,MenuItem,
  Typography,
  IconButton,
  CircularProgress,
   Select, 
   TablePagination,
   Pagination
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useEffect, useState } from "react";
import { showUnderDevelopment } from "../../../../components/Alert.js";
import StatusDropdown from "../../../../components/StatusDropdown";
import { useTranslation } from "react-i18next";
import CustomText, { textStyles } from "../../../../components/CustomText";
 import AttendanceDetailsDrawer from "./DetailsDrawer.js"; // adjust the path
import { GoogleMap, Marker, InfoWindow } from "@react-google-maps/api";
import mapicon from "../../../../assets/Dashboard/mapicon.svg";
import CustomButton from "../../../../components/CustomButton";
import maparrow from "../../../../assets/maparrow.svg";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption";
import { BASE_URL } from "../../../../components/BaseUrl";
import CloseIcon from "@mui/icons-material/Close";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";// ✅ Import DatePicker
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import empty from "../../../../assets/empty.png";
import TruncatedCell from "../../../../components/TruncatedCell.js";
import AttendanceFilterDrawer from "./FilterDrawer"; // correct path
import { convertUTCToLocalDateTime } from "../../../../components/dateTimeUtils";
import {
  getGoogleMapsPinIconForStatus,
  getStatusBadgeBackgroundColor,
} from "../../../../constants/statusPalette";
const defaultCenter = { lat: 37.0902, lng: -95.7129 };
const mapContainerStyle = { width: "100%", height: "100%" };

const HaederStyles = {
  color: "#44546F",
  fontSize: "13px",
  fontFamily: "Poppins, sans-serif",
  fontWeight: 600,
   whiteSpace: 'nowrap', 
      overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const DataStyles = {
  color: "#172B4D",
  fontSize: "13px",
  fontFamily: "Poppins, sans-serif",
  fontWeight: 400,
   whiteSpace: 'nowrap', 
      overflow: 'hidden',
  textOverflow: 'ellipsis',
};
const TimeHeaderStyles = {
  ...HaederStyles,
  minWidth: "90px",
  px: "10px",
};
const TimeCellStyles = {
  ...DataStyles,
  minWidth: "90px",
  px: "10px",
};

const ClientAcquisitionTable = ({ onRowClick ,initialFilter}) => {
  const { t } = useTranslation();
const [showFullMap, setShowFullMap] = useState(false);
const [activePin, setActivePin] = useState(null);
  // const [selectedFilter, setSelectedFilter] = useState(initialFilter || "");
  // const [isFilterApplied, setIsFilterApplied] = useState(Boolean(initialFilter));
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
// useEffect(() => {
//   if (initialFilter) {
//     setSelectedFilter(initialFilter);
//     setIsFilterApplied(true);
//   }
// }, [initialFilter]);

useEffect(() => {
  if (initialFilter) {
    setFilters((prev) => ({
      ...prev,
      status: initialFilter,
    }));
    setIsFilterApplied(true);
  }
}, [initialFilter]);

  // State
  const [tableRows, setTableRows] = useState([]);
  const [mapData, setMapData] = useState(null);
  const [loading, setLoading] = useState(true);
  const mapRef = React.useRef(null);
  const fullMapRef = React.useRef(null);

  // Drawer/menu states
  const [selectedRow, setSelectedRow] = useState(null);

  const [selectedDate, setSelectedDate] = useState(dayjs());
  const formatLocalTime = (utcString) => {
    const localValue = convertUTCToLocalDateTime(utcString, {
      locale: "en-GB",
      formatOptions: { hour: "numeric", minute: "2-digit", hour12: true },
    });
    return localValue === "—" ? "-" : localValue;
  };

  const toDisplayTime = (value) => {
    if (value === null || value === undefined || value === "") return "-";

    const converted = formatLocalTime(value);
    if (converted !== "-") return converted;

    // If API already provides display-ready local text like "3:09 pm", keep it.
    if (typeof value === "string" && value.trim()) return value.trim();
    return "-";
  };

  const [date, setDate] = useState(dayjs());
  const [filterOpen, setFilterOpen] = useState(false);
// const [selectedFilter, setSelectedFilter] = useState("");
// const [isFilterApplied, setIsFilterApplied] = useState(false);
// const [selectedFilter, setSelectedFilter] = useState(initialFilter || "");
const [filters, setFilters] = useState({
  status: initialFilter || "",
   worker: "",
});
  const [isFilterApplied, setIsFilterApplied] = useState(Boolean(initialFilter));
useEffect(() => {
  const fetchData = async () => {
    if (!decryptedToken) {
      console.warn("⚠️ No token found, skipping fetch");
      return;
    }

    try {
      setLoading(true);

      const formattedDate = dayjs(date).format("YYYY-MM-DD");
let url = `${BASE_URL}/company-admins/attendance/today?date=${formattedDate}`;
console.log("➡️ Base URL:", url);

// if (selectedFilter) {
//   url += `&filter=${selectedFilter}`;
//   console.log("🎯 Filter applied:", selectedFilter);
// }

if (filters.status) {
  url += `&filter=${encodeURIComponent(String(filters.status))}`;
}

if (filters.worker) {
  url += `&worker=${encodeURIComponent(String(filters.worker))}`;
}
console.log("🔗 Final API URL:", url);
      console.log("📡 Fetching attendance logs for date:", formattedDate);
      console.log("🔗 Full API URL:", url);

      const res = await fetch(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${decryptedToken}`,
        },
      });

      console.log("📥 Raw response status:", res.status);

      const json = await res.json();
      console.log("✅ API JSON response:", json);

      if (!json.error) {
        setTableRows(json.data.table?.rows || json.data.rows || []);
        const normalizedMap = {
          ...json.data.map,
          pins: (json.data.map?.pins || []).map((p) => ({
            ...p,
            lastStatus:
              p.lastStatus ||
              p.last_status ||
              p.workerStatus ||
              p.worker_status ||
              null,
            workerStatus:
              p.workerStatus ||
              p.worker_status ||
              p.lastStatus ||
              p.last_status ||
              null,
          })),
        };
        setMapData(normalizedMap);

        // Debugging table rows
        console.log("📊 Parsed table rows:", json.data.table?.rows || json.data.rows || []);
        console.log("🗺️ Parsed map data:", json.data.map);
      } else {
        console.warn("⚠️ API returned error:", json.message);
      }
    } catch (err) {
      console.error("❌ Error fetching attendance:", err);
      alert("❌ Error fetching attendance: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [decryptedToken,date, filters]);

const [drawerOpen, setDrawerOpen] = useState(false);

const [selectedPunchId, setSelectedPunchId] = useState(null);
const handleOpenDetails = (row) => {
  setSelectedRow(row);
  setDrawerOpen(true);
};
const [anchorEl, setAnchorEl] = useState(null);
const [menuRow, setMenuRow] = useState(null); // store the clicked row

const handleMenuOpen = (event, row) => {
  setAnchorEl(event.currentTarget);
  setMenuRow(row);
};

const handleMenuClose = () => {
  setAnchorEl(null);
  setMenuRow(null);
};
const formatTimeTo12Hour = (timeString) => {
  const localValue = convertUTCToLocalDateTime(timeString, {
    locale: "en-GB",
    formatOptions: { hour: "numeric", minute: "2-digit", hour12: true },
  });
  return localValue === "—" ? "--" : localValue;
};
const getPunchTimeByAction = (row, actionType) => {
  const punches = Array.isArray(row?.punches) ? row.punches : [];
  const matchedPunch = punches.find((punch) => punch?.actionType === actionType);
  return toDisplayTime(matchedPunch?.occurredAt || matchedPunch?.formattedDateTime || null);
};
const [page, setPage] = useState(1);
const rowsPerPage = 10;

const paginatedRows = tableRows.slice(
  (page - 1) * rowsPerPage,
  page * rowsPerPage
);

const totalPages = Math.ceil(tableRows.length / rowsPerPage);

const getPinColorByStatus = (status) => getStatusBadgeBackgroundColor(status);
const hasPins = Array.isArray(mapData?.pins) && mapData.pins.length > 0;
const filteredPins = React.useMemo(() => {
  if (!mapData?.pins) return [];

  // no row selected → show all pins
  if (!selectedPunchId) return mapData.pins;

  // show only the pin that matches clicked row punchId
  return mapData.pins.filter(
    (p) => p.punchId === selectedPunchId
  );
}, [mapData, selectedPunchId]);
const [openDatePicker, setOpenDatePicker] = useState(false);

const getMapCenter = () =>
  filteredPins.length > 0
    ? {
        lat: filteredPins[0].coordinates.lat,
        lng: filteredPins[0].coordinates.lng,
      }
    : defaultCenter;

const tableStatusByPunchId = React.useMemo(() => {
  const statusMap = new Map();
  tableRows.forEach((row) => {
    if (row?.punchId != null && row?.lastStatus) {
      statusMap.set(String(row.punchId), row.lastStatus);
    }
  });
  return statusMap;
}, [tableRows]);

const tableTimeByPunchId = React.useMemo(() => {
  const timeMap = new Map();
  tableRows.forEach((row) => {
    if (row?.punchId != null && row?.lastPunchTime) {
      timeMap.set(String(row.punchId), row.lastPunchTime);
    }
  });
  return timeMap;
}, [tableRows]);

const getPinStatus = (pin) =>
  (pin?.punchId != null && tableStatusByPunchId.get(String(pin.punchId))) ||
  pin?.lastStatus ||
  pin?.workerStatus ||
  pin?.last_status ||
  pin?.worker_status ||
  "-";

const formatStatusLabel = (status) => {
  if (!status || status === "-") return "-";
  return String(status)
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
const getPinDisplayTime = (pin) =>
  toDisplayTime(
    (pin?.punchId != null && tableTimeByPunchId.get(String(pin.punchId))) ||
    pin?.lastPunchTime ||
      pin?.last_punch_time ||
      pin?.occurredAt ||
      pin?.formattedTime ||
      pin?.punch_time ||
      pin?.time ||
      null
  );

const getMarkerIcon = (status) => getGoogleMapsPinIconForStatus(status);

const fitMapToPins = (map) => {
  if (!map || !window.google?.maps) return;

  if (!filteredPins.length) {
    map.setCenter(defaultCenter);
    map.setZoom(5);
    return;
  }

  if (filteredPins.length === 1) {
    map.setCenter({
      lat: filteredPins[0].coordinates.lat,
      lng: filteredPins[0].coordinates.lng,
    });
    map.setZoom(13);
    return;
  }

  const bounds = new window.google.maps.LatLngBounds();
  filteredPins.forEach((pin) => {
    bounds.extend({
      lat: pin.coordinates.lat,
      lng: pin.coordinates.lng,
    });
  });
  map.fitBounds(bounds, 50);
};

useEffect(() => {
  if (activePin) {
    const stillVisible = filteredPins.some(
      (pin) => (pin.punchId || pin.workerId) === (activePin.punchId || activePin.workerId)
    );
    if (!stillVisible) setActivePin(null);
  }
}, [filteredPins, activePin]);

useEffect(() => {
  fitMapToPins(mapRef.current);
  if (showFullMap) {
    fitMapToPins(fullMapRef.current);
  }
}, [filteredPins, showFullMap]);

const mapStatusLegend = [
  { key: "CLOCK_IN", label: t("clock_in") },
  { key: "EARLY_CLOCK_IN", label: t("early_clock_in") },
  { key: "LATE_ARRIVAL", label: t("late_clock_in") },
  { key: "BREAK", label: t("break_start") },
  { key: "BREAK_END", label: t("break_end") },
  { key: "CLOCK_OUT", label: t("clock_out") },
  { key: "EARLY_CLOCK_OUT", label: t("early_clock_out") },
  { key: "LATE_CLOCK_OUT", label: t("late_clock_out") },
  { key: "ON_LEAVE", label: t("on_leave") },
  { key: "ON_HALF_LEAVE", label: t("on_half_leave") },
  { key: "ABSENT", label: t("absent") },
];
  return (



    <>
    
    
          <Box sx={{ borderRadius: 2, mt: 2, border: "1px solid #091E4224", borderRadius: "6px" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#fff",
          padding: "12px 16px",
          borderRadius: "8px",
          mb: 0,
        }}
      >
        <Typography
          sx={{
            fontSize: "15px",
            fontWeight: 700,
            color: "#212121",
            fontFamily: "Nunito Sans, sans-serif",
          }}
        >
          {t("today_punches")}
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    
             <LocalizationProvider dateAdapter={AdapterDayjs}>

<DatePicker
    //   open={openDatePicker}
    // onClose={() => setOpenDatePicker(false)} 

  value={date}
  onChange={(newDate) => setDate(newDate)}
  format="YYYY-MM-DD"
      maxDate={dayjs()}   
  enableAccessibleFieldDOMStructure={false}
  slotProps={{
    textField: {
      size: "small",
        // onClick: () => setOpenDatePicker(true),   // ✅ FULL FIELD CLICKABLE
        // onFocus: () => setOpenDatePicker(true), 
      sx: {
        "& .MuiInputBase-root": {
          height: 34,
          fontSize: "14px",
        },
        "& .MuiInputBase-input": {
          padding: "2px 6px",
          fontSize: "14px",
        },
        "& .MuiSvgIcon-root": {
          fontSize: "16px",
        },
      },
    },
    popper: {
      sx: {
        "& .MuiPickersCalendarHeader-label": {
          fontSize: "14px", // shrink Month-Year label
          fontWeight: 500,
        },
        "& .MuiPickersCalendarHeader-switchViewButton": {
          fontSize: "12px", // shrink dropdown button
        },
        "& .MuiPickersArrowSwitcher-button": {
          fontSize: "12px", // shrink arrow buttons
        },
        "& .MuiDayCalendar-weekDayLabel": {
          fontSize: "14px", // week day letters (S M T W T F S)
        },
        "& .MuiPickersDay-root": {
          fontSize: "14px", // dates inside the grid
          width: 28,        // shrink day cell width
          height: 28,       // shrink day cell height
          margin: 1,
        },
      },
    },
  }}
/>


  </LocalizationProvider>
         {/* FILTER ICON */}
{isFilterApplied ? (
  <Box
    onClick={() => setFilterOpen(true)}
    sx={{
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 34,
      height: 34,
      borderRadius: 1,
      bgcolor: "#1976D2",
      ml: 1,
      cursor: "pointer",
    }}
  >
    <FilterAltIcon sx={{ color: "white", fontSize: 20 }} />

    {/* Clear Button */}
    <IconButton
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        setFilters({ status: "", worker: "" });
        setIsFilterApplied(false);
      }}
      sx={{
        position: "absolute",
        top: -6,
        right: -6,
        bgcolor: "white",
        width: 18,
        height: 18,
        border: "1px solid #C4C4C4",
      }}
    >
      <CloseRoundedIcon sx={{ fontSize: 14 }} />
    </IconButton>
  </Box>
) : (
  <IconButton
    onClick={() => setFilterOpen(true)}
    sx={{
      border: "1px solid #C4C4C4",
      borderRadius: 1,
      width: 34,
      height: 34,
      ml: 1,
    }}
  >
    <FilterAltIcon />
  </IconButton>
)}


       
        </Box>
      </Box>



      <Box sx={{ borderTop: "1px solid #091E4224" }}>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 2,
      flexWrap: "wrap",
      px: 2,
      py: 1.5,
      backgroundColor: "#fff",
      borderBottom: "1px solid #091E4224",
    }}
  >
    {mapStatusLegend.map((item) => (
      <Box
        key={item.key}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.8,
        }}
      >
        <Box
          sx={{
            width: 14,
            height: 14,
            borderRadius: "50%",
            backgroundColor: getPinColorByStatus(item.key),
          }}
        />
        <Typography
          sx={{
            fontSize: "13px",
            fontWeight: 500,
            color: "#44546F",
            fontFamily: "Poppins, sans-serif",
            whiteSpace: "nowrap",
          }}
        >
          {item.label}
        </Typography>
      </Box>
    ))}
  </Box>
  </Box>

  <Box sx={{ position: "relative", width: "100%", height: 300 }}>
{/* <Box sx={{ position: "relative", width: "100%", height: 300 }}> */}
  <GoogleMap
    mapContainerStyle={mapContainerStyle}
    center={getMapCenter()}
    zoom={13}
    onLoad={(map) => {
      mapRef.current = map;
      fitMapToPins(map);
    }}
    onUnmount={() => {
      mapRef.current = null;
    }}
    options={{
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      scrollwheel: true,
    }}
  >
    {filteredPins?.map((p) => (
      <Marker
        key={p.punchId || p.workerId}
        position={{ lat: p.coordinates.lat, lng: p.coordinates.lng }}
        icon={getMarkerIcon(getPinStatus(p))}
        onClick={() => setActivePin(p)}
      />
    ))}

    {activePin && (
      <InfoWindow
        position={{
          lat: activePin.coordinates.lat,
          lng: activePin.coordinates.lng,
        }}
        onCloseClick={() => setActivePin(null)}
      >
        <Box sx={{ minWidth: 140 }}>
          <Typography sx={{ fontWeight: 700, fontSize: "14px" }}>
            {activePin.workerName}
          </Typography>
          <Typography sx={{ fontSize: "13px" }}>{activePin.email}</Typography>
          <Typography sx={{ fontSize: "13px" }}>
            Status: {formatStatusLabel(getPinStatus(activePin))}
          </Typography>
          <Typography sx={{ fontSize: "13px" }}>
            Time: {getPinDisplayTime(activePin)}
          </Typography>
        </Box>
      </InfoWindow>
    )}
  </GoogleMap>

  <CustomButton 
    onClick={() => setShowFullMap(true)}
   label={ <> {t("dashboard.viewFullMap")}
     <Box component="img" src={maparrow} alt="view icon"
      sx={{ ml: 1, width: 15, height: 13, objectFit: "contain" }} /> </> }
   size="small" sx={{   position: "absolute",
      top: 12,
      right: 12,
      py: 0.5,
      height: 28,
      zIndex: 1000,}} />
</Box>
    </Box>
    
   
    <Box
      sx={{
        mt: 1,
        backgroundColor: "white",
        borderRadius: 2,
        border: "1px solid #091E4224",
        boxShadow: "0px 0px 10px rgba(0,0,0,0.05)",
        overflow: "auto",
   
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          px: 2,
        }}
      ></Box>
      <Box sx={{ overflowX: "auto", width: "100%" }}>
        <TableContainer component={Paper} sx={{ px: 1 }}>
          <Table sx={{ minWidth: 650 }} size="small">
            <TableHead>
              <TableRow>
                {[
                  { label: t("common.id"), isTime: false },
                  { label: t("dashboard.table.fullName"), isTime: false },
                  { label: t("common.email"), isTime: false },
                  { label: t("clock_in"), isTime: true },
                  { label: t("break_start"), isTime: true },
                  { label: t("break_end"), isTime: true },
                  { label: t("clock_out"), isTime: true },
                  { label: t("dashboard.table.location"), isTime: false },
                  { label: t("common.status"), isTime: false },
                  { label: t("common.action"), isTime: false },
                ].map((header) => (
                  <TableCell
                    key={header.label}
                    sx={{
                      ...(header.isTime ? TimeHeaderStyles : HaederStyles),
                      py: "6px",
                      px: header.isTime ? "10px" : "2px",
                      pt: 2,
                    }}
                  >
                    {header.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
         <TableBody>
             
                {loading ? (
    <TableRow>
      <TableCell colSpan={10} align="center">
        <CircularProgress size={24} />
      </TableCell>
    </TableRow>
  ) : tableRows.length === 0 ? (
    <TableRow>
      <TableCell colSpan={10} align="center">
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            py: 5,
          }}
        >
          <img
            src={empty}
            alt="No Data"
            style={{ width: 200, marginBottom: 16 }}
          />
          <CustomText
            sx={{
              ...textStyles.h1,
              fontWeight: 500,
              fontSize: "16px",
              color: "#003149",
            }}
          >
            {t("empty.no_user")}
          </CustomText>
        </Box>
      </TableCell>
    </TableRow>
  ) : (
                paginatedRows.map((row, index) => (
                  <TableRow key={index}
                    sx={{
    height: "36px",
    cursor: "pointer"
  }}
  onClick={() => {
    if (!row.punchId) return;
    setSelectedPunchId(row.punchId);
  }}>
                    <TableCell sx={{ ...DataStyles, py: "6px", px: "2px" }}>{row.workerId}</TableCell>
                    <TableCell sx={{ ...DataStyles, py: "6px", px: "2px" }}>{row.fullName}</TableCell>
                    <TableCell sx={{ ...DataStyles, py: "6px", px: "2px" }}>{row.email}</TableCell>
                    <TableCell sx={{ ...TimeCellStyles, py: "6px", px: "10px" }}>
                      {getPunchTimeByAction(row, "CLOCK_IN")}
                    </TableCell>
                    <TableCell sx={{ ...TimeCellStyles, py: "6px", px: "10px" }}>
                      {getPunchTimeByAction(row, "BREAK_START")}
                    </TableCell>
                    <TableCell sx={{ ...TimeCellStyles, py: "6px", px: "10px" }}>
                      {getPunchTimeByAction(row, "BREAK_END")}
                    </TableCell>
                    <TableCell sx={{ ...TimeCellStyles, py: "6px", px: "10px" }}>
                      {getPunchTimeByAction(row, "CLOCK_OUT")}
                    </TableCell>
                    <TableCell sx={{ ...DataStyles, py: "6px", px: "4px" }}>
                      {/* {row.locationText} */}
                   
  {/* {row.location?.text || "-"} */}
  <TruncatedCell text={row.location?.text || "-"} maxLength={30} />
 


                    </TableCell>
                    <TableCell sx={{ ...DataStyles, py: "6px", px: "4px" }}>
                      <Box sx={{ pointerEvents: "none" }}>
                        <StatusDropdown currentStatus={row.lastStatus} />
                      </Box>
                    </TableCell>
                    <TableCell>
                      <IconButton size="small" onClick={(e) => handleMenuOpen(e, row)}>
                        <MoreVertIcon fontSize="small" />
                      </IconButton>
                   
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
   <Menu
  anchorEl={anchorEl}
  open={Boolean(anchorEl)}
  onClose={handleMenuClose}
  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
  transformOrigin={{ vertical: "top", horizontal: "right" }}
>
 
     <MenuItem   
     onClick={() => {
      if (menuRow) {
        handleOpenDetails(menuRow); // use the stored row
      }
      handleMenuClose();
    }}
          sx={{ fontSize: 13, fontFamily: "Poppins, sans-serif" }}>
              {t("unvalidatedPunches.tableActions.view")}
          </MenuItem>
</Menu>
        </TableContainer>
<Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
  <Pagination
    count={totalPages}
    page={page}
    onChange={(e, value) => setPage(value)}
    color="primary"
    shape="rounded"
  />
</Box>
      </Box>
   <AttendanceDetailsDrawer
  open={drawerOpen}
  onClose={() => setDrawerOpen(false)}
  selectedRow={selectedRow}
/>

{selectedPunchId && (
  <IconButton
    onClick={() => setSelectedPunchId(null)}
    sx={{
      width: 30,
      height: 30,
      position: "absolute",
      top: 30,
    left: 240,
      zIndex: 1200,
      backgroundColor: "red",
      "&:hover": { backgroundColor: "red" },
    }}
  >
    <CloseRoundedIcon sx={{ color: "white" }} />
  </IconButton>
)}
      {showFullMap && (
  <Box
    sx={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "#fff",
      zIndex: 2000,
    }}
  >
    {/* Close button */}
    <IconButton
      onClick={() => setShowFullMap(false)}
      sx={{ position: "absolute", top: 16, right: 16, zIndex: 2100,backgroundColor:"white",
        "&:hover": { backgroundColor: "white" }
       }}
    >
     <CloseIcon sx={{color:"red"}} />
    </IconButton>

    {/* Fullscreen map */}
  <GoogleMap
    mapContainerStyle={mapContainerStyle}
    center={getMapCenter()}
    zoom={13}
    onLoad={(map) => {
      fullMapRef.current = map;
      fitMapToPins(map);
    }}
    onUnmount={() => {
      fullMapRef.current = null;
    }}
    options={{
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      scrollwheel: true,
    }}
  >
    {filteredPins?.map((p) => (
      <Marker
        key={p.punchId || p.workerId}
        position={{ lat: p.coordinates.lat, lng: p.coordinates.lng }}
        icon={getMarkerIcon(getPinStatus(p))}
        onClick={() => setActivePin(p)}
      />
    ))}

    {activePin && (
      <InfoWindow
        position={{
          lat: activePin.coordinates.lat,
          lng: activePin.coordinates.lng,
        }}
        onCloseClick={() => setActivePin(null)}
      >
        <Box sx={{ minWidth: 140 }}>
          <Typography sx={{ fontWeight: 700, fontSize: "14px" }}>
            {activePin.workerName}
          </Typography>
          <Typography sx={{ fontSize: "13px" }}>{activePin.email}</Typography>
          <Typography sx={{ fontSize: "13px" }}>
            Status: {formatStatusLabel(getPinStatus(activePin))}
          </Typography>
          <Typography sx={{ fontSize: "13px" }}>
            Time: {getPinDisplayTime(activePin)}
          </Typography>
        </Box>
      </InfoWindow>
    )}
  </GoogleMap>
  </Box>
)}
    </Box>
    {/* <AttendanceFilterDrawer
  open={filterOpen}
  onClose={() => setFilterOpen(false)}
  selectedFilter={selectedFilter}
  setSelectedFilter={setSelectedFilter}
  setIsFilterApplied={setIsFilterApplied}
/> */}
<AttendanceFilterDrawer
  open={filterOpen}
  onClose={() => setFilterOpen(false)}
  filters={filters}
  setFilters={setFilters}
  setIsFilterApplied={setIsFilterApplied}
/>
     </>
  );
};

export default ClientAcquisitionTable;





